import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useRef, useEffect, useContext } from 'react';
import { FCTheme } from '../../../theming/FCTheme.js';
import { Overlay, StyledDialog } from './style.js';
import { DialogProvider } from './DialogContext.js';

var DialogComponent = function DialogComponent(_a) {
  var _b = _a.boxShadow,
      boxShadow = _b === void 0 ? true : _b,
      visible = _a.visible,
      id = _a.id,
      children = _a.children,
      _c = _a.onCloseClick,
      onCloseClick = _c === void 0 ? function () {
    return undefined;
  } : _c,
      _d = _a.fixed,
      fixed = _d === void 0 ? true : _d,
      fcStyle = _a.fcStyle,
      _e = _a.showOverlay,
      showOverlay = _e === void 0 ? true : _e,
      focusElement = _a.focusElement,
      rest = __rest(_a, ["boxShadow", "visible", "id", "children", "onCloseClick", "fixed", "fcStyle", "showOverlay", "focusElement"]);

  var closeButton = useRef(null);
  var dialogRef = useRef(null);
  useEffect(function () {
    var _a, _b;

    if (fixed) if (focusElement) {
      (_a = document.getElementById(focusElement)) === null || _a === void 0 ? void 0 : _a.focus();
    } else {
      (_b = closeButton.current) === null || _b === void 0 ? void 0 : _b.focus();
    }
  }, []);

  var handleDialogKeyDown = function handleDialogKeyDown(e) {
    var _a;

    if (e.key === 'Tab') {
      var toSearch = document;

      if (dialogRef) {
        toSearch = dialogRef.current;
      }

      var focusable = toSearch.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var lastFocusable = focusable[focusable.length - 1];

      if (lastFocusable) {
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          (_a = closeButton.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
      }
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      onCloseClick();
    }
  };

  var theme = useContext(FCTheme);
  var state = {
    theme: theme.theme,
    onCloseClick: onCloseClick,
    closeButton: closeButton,
    fcStyle: fcStyle
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showOverlay && /*#__PURE__*/React.createElement(Overlay, {
    "data-testid": "dialog-overlay",
    onClick: function onClick() {
      return onCloseClick();
    }
  }), /*#__PURE__*/React.createElement(DialogProvider, {
    state: state
  }, ' ', /*#__PURE__*/React.createElement(StyledDialog, __assign({
    ref: dialogRef,
    onKeyDown: function onKeyDown(e) {
      return handleDialogKeyDown(e);
    },
    id: id,
    fcStyle: fcStyle,
    theme: theme.theme,
    visible: visible,
    fixed: fixed,
    boxShadow: boxShadow,
    role: "dialog"
  }, rest), children)));
};

export { DialogComponent };